import { render, staticRenderFns } from "./PaginationNav.vue?vue&type=template&id=5026ee14&scoped=true"
import script from "./PaginationNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationNav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PaginationNav.vue?vue&type=style&index=0&id=5026ee14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5026ee14",
  null
  
)

export default component.exports